window.autoHeightAnimate = function autoHeightAnimate($el, time) {
    var method = $el.css('box-sizing') === 'border-box' ? 'outerHeight' : 'height';
    var curHeight = $el[method](),
        autoHeight = $el.css({height: 'auto'})[method]();
    $el.css({height: curHeight});
    $el.stop().animate({height: autoHeight}, time);
}